export const getPartnerContactsTableHead = canManage => ({
  cells: [{
    key: 'name',
    content: 'Name'
  }, {
    key: 'role',
    content: 'Role'
  }, {
    key: 'email',
    content: 'Email'
  }, canManage && {
    key: 'actions',
    content: 'Actions'
  }]
});